import { TObject } from "constants/interfaces";

const extractParamsFromURL = (query = window.location.href) => {
  const flags: TObject = {};

  const flagsArray = query.split("&");
  flagsArray.forEach((f) => {
    let flag = f;
    if (flag.includes("?")) {
      flag = flag.split("?")[1];
    }
    const [key, value] = flag.split("=");
    flags[key] = value;
  });
  return flags;
};

export default extractParamsFromURL;
